import axios from 'axios';
import { api, headers } from '../../app/conf';

export const getSuggestedContactsTagsService = (token, value) =>
    axios({
        method: 'get',
        url: `${api}/v1/tags`,
        headers: {
            ...headers,
            'X-Access-Token': token
        },
        params: { 
            value,
            type: 'contact'
        }
    })

export const postSuggestedContactsTagsService = (token, value) =>
    axios({
        method: 'post',
        url: `${api}/v1/tags`,
        headers: {
            ...headers,
            'X-Access-Token': token
        },
        data: {
            type: 'contact',
            value
        }
    })